/**
 * Monero integrated address model.
 */
export default class MoneroIntegratedAddress {
    constructor(integratedAddress) {
        Object.assign(this, integratedAddress);
    }
    toJson() {
        return Object.assign({}, this);
    }
    getStandardAddress() {
        return this.standardAddress;
    }
    setStandardAddress(standardAddress) {
        this.standardAddress = standardAddress;
        return this;
    }
    getPaymentId() {
        return this.paymentId;
    }
    setPaymentId(paymentId) {
        this.paymentId = paymentId;
        return this;
    }
    getIntegratedAddress() {
        return this.integratedAddress;
    }
    setIntegratedAddress(integratedAddress) {
        this.integratedAddress = integratedAddress;
        return this;
    }
    toString() {
        return this.integratedAddress;
    }
}
